/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_BadgeInputs */

const id_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ms_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const da_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const de_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const en_us2_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const es_es2_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítem`)
};

const es_mx2_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítem`)
};

const fil_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const fr_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const it_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articolo`)
};

const hu_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elem`)
};

const nl_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const no_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const pl_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const pt_br2_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const pt_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ro_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const fi_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohde`)
};

const sv_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt`)
};

const vi_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục`)
};

const tr_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğe`)
};

const cs_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položka`)
};

const bg_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обект`)
};

const ru_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объект`)
};

const uk_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елемент`)
};

const ar_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنصر`)
};

const hi_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम`)
};

const th_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการ`)
};

const ja_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム`)
};

const zh_cn2_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const zh_hant1_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const ko_items_badge = /** @type {(inputs: Items_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템`)
};

/**
* | output |
* | --- |
* | "Item" |
*
* @param {Items_BadgeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_badge = /** @type {((inputs?: Items_BadgeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_BadgeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_badge(inputs)
	if (locale === "ms") return ms_items_badge(inputs)
	if (locale === "da") return da_items_badge(inputs)
	if (locale === "de") return de_items_badge(inputs)
	if (locale === "en-US") return en_us2_items_badge(inputs)
	if (locale === "es-ES") return es_es2_items_badge(inputs)
	if (locale === "es-MX") return es_mx2_items_badge(inputs)
	if (locale === "fil") return fil_items_badge(inputs)
	if (locale === "fr") return fr_items_badge(inputs)
	if (locale === "it") return it_items_badge(inputs)
	if (locale === "hu") return hu_items_badge(inputs)
	if (locale === "nl") return nl_items_badge(inputs)
	if (locale === "no") return no_items_badge(inputs)
	if (locale === "pl") return pl_items_badge(inputs)
	if (locale === "pt-BR") return pt_br2_items_badge(inputs)
	if (locale === "pt") return pt_items_badge(inputs)
	if (locale === "ro") return ro_items_badge(inputs)
	if (locale === "fi") return fi_items_badge(inputs)
	if (locale === "sv") return sv_items_badge(inputs)
	if (locale === "vi") return vi_items_badge(inputs)
	if (locale === "tr") return tr_items_badge(inputs)
	if (locale === "cs") return cs_items_badge(inputs)
	if (locale === "bg") return bg_items_badge(inputs)
	if (locale === "ru") return ru_items_badge(inputs)
	if (locale === "uk") return uk_items_badge(inputs)
	if (locale === "ar") return ar_items_badge(inputs)
	if (locale === "hi") return hi_items_badge(inputs)
	if (locale === "th") return th_items_badge(inputs)
	if (locale === "ja") return ja_items_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_items_badge(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_badge(inputs)
	return ko_items_badge(inputs)
});
export { items_badge as "items.badge" }